/* Cozy Home ozel scriptleri: 'Sepette' fiyat + kampanya rozeti (Discount) ve marka adi temizleme (Brands Clean).
   Shopify Dosyalar'da barindirilir; tema guncellemelerinden etkilenmez.
   Degisiklik icin: bu dosyayi duzenle, Dosyalar'a ayni adla yeniden yukle, Custom Liquid'deki URL'yi guncelle.
   Baslatma: sayfa 'load' olayindan sonra, tarayici bosta kalinca (requestIdleCallback, en gec 3 sn) calisir;
   boylece LCP/FCP olcumlerini ve ilk etkilesimi engellemez. */
(function () {
  function cozyStart() {

/* ===== Discount (Sepette fiyat) ===== */
(function () {
  'use strict';
  var __cfg = window.cozyCd || {};
  var TOKEN = (__cfg.TOKEN !== undefined ? __cfg.TOKEN : "bcfe741d3df9479a6f7e22c9a141410d");
  if (!TOKEN || TOKEN.indexOf('BURAYA') === 0 || !window.fetch || !window.Promise) return;

  var API_VERSION = (__cfg.API_VERSION !== undefined ? __cfg.API_VERSION : "2026-07");
  var ENDPOINT = location.origin + '/api/' + API_VERSION + '/graphql.json';
  var LABEL = (__cfg.LABEL !== undefined ? __cfg.LABEL : "Sepette");
  var SHOW_OLD = (__cfg.SHOW_OLD !== undefined ? __cfg.SHOW_OLD : false);
  var FORCE_TR = (__cfg.FORCE_TR !== undefined ? __cfg.FORCE_TR : true);
  var HIDE_PRICE = (__cfg.HIDE_PRICE !== undefined ? __cfg.HIDE_PRICE : false);
  var BADGE = (__cfg.BADGE !== undefined ? __cfg.BADGE : true);
  var DEALS = (__cfg.DEALS !== undefined ? __cfg.DEALS : true);
  var DEAL_QTY = Math.max(2, parseInt(__cfg.DEAL_QTY !== undefined ? __cfg.DEAL_QTY : 4, 10) || 4);
  var DEAL_FREE = (__cfg.DEAL_FREE !== undefined ? __cfg.DEAL_FREE : "{n} AL {x} ÖDE");
  var DEAL_PCT = (__cfg.DEAL_PCT !== undefined ? __cfg.DEAL_PCT : "{n}. ÜRÜNE %{p}");
  var DEAL_TEXT = (__cfg.DEAL_TEXT !== undefined ? __cfg.DEAL_TEXT : "");
  var DEAL_TITLE = (__cfg.DEAL_TITLE !== undefined ? __cfg.DEAL_TITLE : false);
  var COUNTRY = (__cfg.COUNTRY !== undefined ? __cfg.COUNTRY : "TR");
  var PROD_HANDLE = (window.cozyCtx && window.cozyCtx.prod) || "";
  var COLL_HANDLE = (window.cozyCtx && window.cozyCtx.coll) || "";
  var ROOT        = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var PRICE_SEL  = '.price:not(.cd-note)';
  var CACHE_KEY  = 'cdSf:v9';
  var CACHE_TTL  = 15 * 60 * 1000;
  var BATCH      = 15;
  var DEAL_BATCH = 8;
  var GAP        = 400;
  var RETRIES    = 3;

  var cache = { t: Date.now(), variants: {}, prices: {}, deals: {}, dealSeen: 0 };
  try {
    var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if (c && (Date.now() - c.t) < CACHE_TTL) cache = c;
  } catch (e) {}
  cache.deals = cache.deals || {};
  var saveTimer = null;
  function saveCache() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
    }, 200);
  }

  function sleep(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

  function gql(query, variables, attempt) {
    attempt = attempt || 0;
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      var retryAfter = parseFloat(r.headers.get('Retry-After')) || 0;
      if (r.status === 429 || r.status === 430) return { throttled: true, wait: retryAfter };
      if (!r.ok) return { throttled: false, data: {} };
      return r.json().then(function (j) {
        var th = (j.errors || []).some(function (e) {
          return e && e.extensions && e.extensions.code === 'THROTTLED';
        });
        return { throttled: th, wait: retryAfter, data: j.data || {} };
      });
    }).then(function (res) {
      if (res.throttled && attempt < RETRIES) {
        var wait = (res.wait ? res.wait * 1000 : 1500 * Math.pow(2, attempt)) + Math.random() * 300;
        return sleep(wait).then(function () { return gql(query, variables, attempt + 1); });
      }
      return res;
    }).catch(function () { return { throttled: true, data: {} }; });
  }

  function pickVariant(vs) {
    for (var k = 0; k < vs.length; k++) if (vs[k].available) return vs[k];
    return vs[0];
  }

  var collLoaded = null;
  function loadCollection() {
    if (!COLL_HANDLE) return Promise.resolve();
    if (collLoaded) return collLoaded;
    collLoaded = fetch(ROOT + 'collections/' + COLL_HANDLE + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        ((d && d.products) || []).forEach(function (p) {
          var v = pickVariant(p.variants || []);
          if (v) cache.variants[p.handle] = 'gid://shopify/ProductVariant/' + v.id;
        });
        saveCache();
      }).catch(function () {});
    return collLoaded;
  }

  function resolveVariants(handles) {
    handles = handles.filter(function (h) { return !cache.variants[h]; });
    if (!handles.length) return Promise.resolve();
    return loadCollection().then(function () {
      handles = handles.filter(function (h) { return !cache.variants[h]; });
      if (!handles.length) return;
      var idx = 0;
      function worker() {
        if (idx >= handles.length) return Promise.resolve();
        var h = handles[idx++];
        return fetch(ROOT + 'products/' + h + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var v = p && pickVariant(p.variants || []);
            if (v) cache.variants[h] = 'gid://shopify/ProductVariant/' + v.id;
          })
          .catch(function () {})
          .then(worker);
      }
      var lanes = [];
      for (var i = 0; i < Math.min(4, handles.length); i++) lanes.push(worker());
      return Promise.all(lanes).then(saveCache);
    });
  }

  var ALLOC = 'discountAllocations{discountedAmount{amount}' +
    '...on CartAutomaticDiscountAllocation{title}...on CartCustomDiscountAllocation{title}' +
    '...on CartCodeDiscountAllocation{code}}';
  var LINE_FIELDS = 'quantity merchandise{...on ProductVariant{id}}' +
    'cost{amountPerQuantity{amount}subtotalAmount{amount}totalAmount{amount}}' + ALLOC;

  function num(m) { return (m && parseFloat(m.amount)) || 0; }
  function r2(v) { return Math.round(v * 100) / 100; }
  function allocKey(a) { return a.title || a.code || '?'; }
  function lineId(ln) { return ln.merchandise && ln.merchandise.id; }

  function dealKeys(lines) {
    var keys = {};
    lines.forEach(function (ln) {
      var sub = num(ln.cost.subtotalAmount);
      (ln.discountAllocations || []).forEach(function (a) {
        var v = num(a.discountedAmount);
        if (v === 0 || (sub > 0 && v >= sub - 0.005)) keys[allocKey(a)] = true;
      });
    });
    return keys;
  }

  function readLine(line, skip) {
    var o = num(line.cost.subtotalAmount);
    var t = o;
    (line.discountAllocations || []).forEach(function (a) {
      if (!skip[allocKey(a)]) t -= num(a.discountedAmount);
    });
    return { o: o, d: Math.max(0, r2(t)) };
  }

  var inflight = {};
  var queue = Promise.resolve();

  var CART_FIELDS = 'cart{discountAllocations{discountedAmount{amount}}' +
    'lines(first:50){nodes{' + LINE_FIELDS + '}}}';

  function createMultiCart(ids) {
    var lines = ids.map(function (id) { return '{merchandiseId:' + JSON.stringify(id) + ',quantity:1}'; }).join(',');
    var q = 'mutation{c:cartCreate(input:{lines:[' + lines + '],buyerIdentity:{countryCode:' + COUNTRY + '}}){' +
            CART_FIELDS + 'userErrors{message}}}';
    return gql(q).then(function (res) {
      if (res.throttled) return null;
      var cart = res.data.c && res.data.c.cart;
      if (!cart) return null;
      if ((cart.discountAllocations || []).length) return { orderLevel: true };
      var nodes = (cart.lines && cart.lines.nodes) || [];
      var skip = dealKeys(nodes);
      var out = {};
      nodes.forEach(function (ln) {
        var id = lineId(ln);
        if (id && !out[id]) out[id] = readLine(ln, skip);
      });
      return { prices: out, deal: Object.keys(skip).length > 0 };
    });
  }

  function createSingleCarts(ids) {
    var out = {};
    var chain = Promise.resolve();
    ids.forEach(function (id, i) {
      chain = chain.then(function () {
        return (i ? sleep(GAP) : Promise.resolve()).then(function () {
          var q = 'mutation($v:ID!){c:cartCreate(input:{lines:[{merchandiseId:$v,quantity:1}],buyerIdentity:{countryCode:' + COUNTRY + '}}){' + CART_FIELDS + '}}';
          return gql(q, { v: id });
        }).then(function (res) {
          if (res.throttled) return;
          var cart = res.data.c && res.data.c.cart;
          if (!cart) return;
          var nodes = (cart.lines && cart.lines.nodes) || [];
          if (!nodes[0]) { out[id] = { o: 0, d: 0 }; return; }
          var p = readLine(nodes[0], dealKeys(nodes));
          var t = p.d;
          (cart.discountAllocations || []).forEach(function (a) { t -= num(a.discountedAmount); });
          p.d = Math.max(0, r2(t));
          out[id] = p;
        });
      });
    });
    return chain.then(function () { return out; });
  }

  function resolvePrices(ids) {
    ids = ids.filter(function (v, i, a) { return v && !cache.prices[v] && !inflight[v] && a.indexOf(v) === i; });
    if (!ids.length) return Promise.resolve();
    ids.forEach(function (id) { inflight[id] = true; });

    var chunks = [];
    for (var i = 0; i < ids.length; i += BATCH) chunks.push(ids.slice(i, i + BATCH));

    var p = queue.then(function () {
      var chain = Promise.resolve();
      chunks.forEach(function (chunk, ci) {
        chain = chain.then(function () {
          return (ci ? sleep(GAP) : Promise.resolve())
            .then(function () { return createMultiCart(chunk); })
            .then(function (r) {
              if (r && r.orderLevel) return createSingleCarts(chunk);
              if (r && r.prices) {
                if (r.deal) cache.dealSeen = Date.now();

                chunk.forEach(function (id) { if (!r.prices[id]) r.prices[id] = { o: 0, d: 0 }; });
                return r.prices;
              }
              return {};
            })
            .then(function (prices) {
              chunk.forEach(function (id) {
                delete inflight[id];
                if (prices[id]) cache.prices[id] = prices[id];
              });
            });
        });
      });
      return chain;
    }).catch(function () { ids.forEach(function (id) { delete inflight[id]; }); });
    queue = p;
    return p.then(saveCache);
  }

  var dealInflight = {};
  var dealQueue = Promise.resolve();

  function gcd(a, b) { return b ? gcd(b, a % b) : a; }

  function parseDeal(nodes) {
    var zero = {};
    nodes.forEach(function (ln) {
      (ln.discountAllocations || []).forEach(function (a) {
        if (num(a.discountedAmount) === 0) zero[allocKey(a)] = true;
      });
    });
    var best = { x: 0 };
    Object.keys(zero).forEach(function (k) {
      var buy = 0, get = 0, disc = 0, paid = 0;
      nodes.forEach(function (ln) {
        var mine = (ln.discountAllocations || []).filter(function (a) { return allocKey(a) === k; });
        if (!mine.length) return;
        var amt = mine.reduce(function (s, a) { return s + num(a.discountedAmount); }, 0);
        if (amt > 0) { get += ln.quantity; disc += amt; } else buy += ln.quantity;
        paid += num(ln.cost.totalAmount);
      });
      var o = num(nodes[0].cost.amountPerQuantity);
      if (!buy || !get || !o) return;
      var g = gcd(buy, get);
      var d = { t: k, x: buy / g, y: get / g, p: Math.round(disc / (get * o) * 100), u: r2(paid / (buy + get)), o: o };
      if (!best.x || d.u < best.u) best = d;
    });
    return best;
  }

  function dealChunk(chunk) {
    var q = 'mutation{' + chunk.map(function (id, i) {
      return 'd' + i + ':cartCreate(input:{lines:[{merchandiseId:' + JSON.stringify(id) + ',quantity:' + DEAL_QTY +
             '}],buyerIdentity:{countryCode:' + COUNTRY + '}}){cart{lines(first:20){nodes{' + LINE_FIELDS + '}}}}';
    }).join('') + '}';
    return gql(q).then(function (res) {
      if (res.throttled) return;
      if (!res.data.d0) {
        if (chunk.length < 2) return;
        var mid = Math.ceil(chunk.length / 2);
        return dealChunk(chunk.slice(0, mid)).then(function () { return sleep(GAP); })
          .then(function () { return dealChunk(chunk.slice(mid)); });
      }
      chunk.forEach(function (id, i) {
        var c = res.data['d' + i];
        if (!c || !c.cart) return;
        var nodes = ((c.cart.lines && c.cart.lines.nodes) || []).filter(function (ln) { return lineId(ln) === id; });
        cache.deals[id] = nodes.length ? parseDeal(nodes) : { x: 0 };
      });
    });
  }

  function resolveDeals(ids) {
    ids = ids.filter(function (v, i, a) { return v && !cache.deals[v] && !dealInflight[v] && a.indexOf(v) === i; });
    if (!ids.length) return Promise.resolve();
    ids.forEach(function (id) { dealInflight[id] = true; });

    var chunks = [];
    for (var i = 0; i < ids.length; i += DEAL_BATCH) chunks.push(ids.slice(i, i + DEAL_BATCH));

    var p = dealQueue.then(function () {
      var chain = Promise.resolve();
      chunks.forEach(function (chunk, ci) {
        chain = chain.then(function () {
          return (ci ? sleep(GAP) : Promise.resolve()).then(function () { return dealChunk(chunk); });
        });
      });
      return chain;
    }).catch(function () {}).then(function () {
      ids.forEach(function (id) { delete dealInflight[id]; });
    });
    dealQueue = p;
    return p.then(saveCache);
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function parseMoney(str) {
    var m = str.match(/[\d.,]+/);
    if (!m) return null;
    var raw = m[0];
    var out = { prefix: str.slice(0, m.index), suffix: str.slice(m.index + raw.length), decSep: '', groupSep: '', decimals: 0 };
    var decPos = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(','));
    if (decPos > -1) {
      var sep = raw.charAt(decPos), after = raw.length - decPos - 1, count = raw.split(sep).length - 1;
      if (after <= 2 && count === 1) { out.decSep = sep; out.decimals = after; out.groupSep = (sep === '.') ? ',' : '.'; }
      else out.groupSep = sep;
    }
    var norm = raw;
    if (out.groupSep) norm = norm.split(out.groupSep).join('');
    if (out.decSep)   norm = norm.split(out.decSep).join('.');
    out.value = parseFloat(norm);
    return isNaN(out.value) ? null : out;
  }
  function group(s, sep) { return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s; }
  function currencyOf(f) { return (f.suffix + ' ' + f.prefix).replace(/[\d.,\s]/g, '').trim() || 'TL'; }
  function formatMoney(val, f) {
    if (FORCE_TR) { var s = val.toFixed(2).split('.'); return group(s[0], '.') + ',' + s[1] + ' ' + currencyOf(f); }
    var t = f.decimals > 0 ? val.toFixed(f.decimals) : String(Math.round(val));
    var p = t.split('.');
    return f.prefix + group(p[0], f.groupSep) + (p[1] ? f.decSep + p[1] : '') + f.suffix;
  }
  function badgeText(o, d, f) {
    var pct = (1 - d / o) * 100;
    if (Math.abs(pct - Math.round(pct)) < 0.3) return '%' + Math.round(pct);
    var amt = o - d;
    return (amt % 1 === 0 ? group(String(amt), '.') : amt.toFixed(2).replace('.', ',')) + ' ' + currencyOf(f) + ' indirim';
  }

  function fillTpl(tpl, vars, money) {
    return String(tpl).split(/(\{(?:unit|total)\})/).map(function (part) {
      if (part === '{unit}' || part === '{total}')
        return '<bdi class="cd-note__new">' + esc(formatMoney(vars[part.slice(1, -1)], money)) + '</bdi>';
      part = fillText(part, vars).trim();
      return part ? '<span class="cd-note__label">' + esc(part) + '</span>' : '';
    }).join('');
  }
  function fillText(tpl, vars) {
    return String(tpl).replace(/\{(\w+)\}/g, function (all, k) { return (k in vars) ? vars[k] : all; });
  }
  function dealBadge(deal, vars) {
    if (DEAL_TITLE) return deal.t;
    if (deal.p >= 100) return fillText(DEAL_FREE, vars);
    if (deal.y === 1) return fillText(DEAL_PCT, vars);
    return deal.t;
  }

  function handleOf(root) {
    var a = root && root.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function currentPriceEl(box) {
    return box.querySelector('.price__sale .price-item--sale')
        || box.querySelector('.price__regular .price-item--regular')
        || box.querySelector('.price-item--sale')
        || box.querySelector('.price-item--regular');
  }
  function productVariantId() {
    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = inp && inp.value;
    if (!id) { var m = location.search.match(/[?&]variant=(\d+)/); id = m && m[1]; }
    return id ? 'gid://shopify/ProductVariant/' + id : null;
  }
  function cardHandle(box) {
    var node = box.parentElement, depth = 0, h = null;
    while (node && node !== document.body && depth < 8 && !h) { h = handleOf(node); node = node.parentElement; depth++; }
    return h;
  }

  function findNote(box, kind) {
    var n = box.nextElementSibling;
    while (n && n.classList && n.classList.contains('cd-note')) {
      if (n.getAttribute('data-kind') === kind) return n;
      n = n.nextElementSibling;
    }
    return null;
  }
  function putNote(box, kind, stamp, html, label) {
    var note = findNote(box, kind);
    if (note && note.getAttribute('data-cd') === stamp) return;
    if (!note) {
      note = document.createElement('div');
      note.className = 'cd-note' + (kind === 'deal' ? ' cd-note--deal' : '');
      note.setAttribute('data-kind', kind);
      note.setAttribute('data-nosnippet', '');
      note.setAttribute('aria-label', label);
      var after = kind === 'deal' ? (findNote(box, 'price') || box) : box;
      after.parentNode.insertBefore(note, after.nextSibling);
    }
    note.setAttribute('data-cd', stamp);
    note.innerHTML = html;
  }

  function decorate(box, p, deal) {
    var hasPrice = p && p.d < p.o;
    var hasDeal  = DEALS && deal && deal.x > 0 && deal.u < deal.o;
    if (!hasPrice && !hasDeal) return;
    var el = currentPriceEl(box);
    if (!el) return;
    var src = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var money = src && parseMoney(src);
    if (!money) return;

    if (hasPrice) {
      var newVal = r2(money.value * (p.d / p.o));
      var html = '';
      if (LABEL) html += '<span class="cd-note__label">' + esc(LABEL) + '</span>';
      html += '<bdi class="cd-note__new">' + esc(formatMoney(newVal, money)) + '</bdi>';
      if (SHOW_OLD) html += '<s class="cd-note__old"><bdi>' + esc(formatMoney(money.value, money)) + '</bdi></s>';
      if (BADGE)    html += '<span class="cd-note__badge">' + esc(badgeText(p.o, p.d, money)) + '</span>';
      putNote(box, 'price', src + '|' + p.d, html, 'Sepette indirimli fiyat');
      if (HIDE_PRICE) box.classList.add('cd-hidden');
    }

    if (hasDeal) {
      var unit = r2(money.value * (deal.u / deal.o));
      var n = deal.x + deal.y;
      var vars = { n: n, x: deal.x, y: deal.y, p: deal.p, unit: unit, total: r2(unit * n) };
      var badge = dealBadge(deal, vars);
      var dhtml = (badge ? '<span class="cd-note__badge">' + esc(badge) + '</span>' : '') + fillTpl(DEAL_TEXT, vars, money);
      putNote(box, 'deal', src + '|' + deal.u + '|' + n, dhtml, 'Adet kampanyasi: ' + fillText(DEAL_FREE, vars));
    }
  }

  var pending = [];
  var seen = new WeakSet();
  var io = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      pending.push(en.target);
    });
    if (pending.length) schedule();
  }, { rootMargin: '400px 0px' }) : null;

  function collectBoxes() {
    var boxes = document.querySelectorAll(PRICE_SEL);
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (seen.has(box) || box.closest('.product__info-container')) continue;
      seen.add(box);
      if (io) io.observe(box); else pending.push(box);
    }
  }

  var busy = false, again = false;
  function run() {
    if (busy) { again = true; return; }
    busy = true;

    collectBoxes();
    var items = [];
    pending.forEach(function (box) {
      if (!box.isConnected) return;
      var h = cardHandle(box);
      if (h) items.push({ box: box, handle: h });
    });
    pending = [];

    var pvid = PROD_HANDLE ? productVariantId() : null;
    var pboxes = pvid ? document.querySelectorAll('.product__info-container ' + PRICE_SEL) : [];

    function paint() {
      items.forEach(function (it) {
        var vid = cache.variants[it.handle];
        if (vid) decorate(it.box, cache.prices[vid], cache.deals[vid]);
      });
      if (pvid) for (var k = 0; k < pboxes.length; k++) decorate(pboxes[k], cache.prices[pvid], cache.deals[pvid]);
    }

    var handles = [];
    items.forEach(function (it) {
      if (!cache.variants[it.handle] && handles.indexOf(it.handle) < 0) handles.push(it.handle);
    });
    paint();

    resolveVariants(handles).then(function () {
      var vids = items.map(function (it) { return cache.variants[it.handle]; });
      if (pvid) vids.push(pvid);
      return resolvePrices(vids).then(function () {
        paint();
        if (!DEALS) return;

        var dv = pvid ? [pvid] : [];
        if (cache.dealSeen) dv = dv.concat(vids);
        resolveDeals(dv).then(paint);
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 100); }

  function boot() {
    run();
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects, variant-radios, variant-picker, form[action*="/cart/add"]')) schedule();
    });
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var tgt = muts[i].target;

          if (tgt.closest && tgt.closest('.cd-note')) continue;
          if (muts[i].addedNodes.length || muts[i].type === 'characterData') { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  function start() {
    if (window.requestIdleCallback) requestIdleCallback(boot, { timeout: 1500 });
    else setTimeout(boot, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ===== Brands Clean ===== */
(function () {
  'use strict';

  /* ================= AYARLAR ================= */
  var CONFIG = {
    // Temizlenecek marka adları (büyük/küçük harf duyarsız)
    BRANDS: ['Cotton Box', 'Cozy Home', 'Casa Carina'],

    // Sadece başlığın BAŞINDAKİ markayı sil (true) — ya da geçtiği her yerde (false)
    ONLY_PREFIX: true,

    // Başlık metninin bulunduğu öğeler (Dawn ve türevleri için hazır)
    SELECTORS: [
      '.card__heading',                     // ürün kartları (koleksiyon, öneriler, arama)
      '.card-information__text',            // eski Dawn kartları
      '.product__title a',                  // featured-product bölümü
      '.cart-item__name',                   // sepet & sepet çekmecesi
      '.predictive-search__item-heading',   // canlı arama sonuçları
      '.cart-notification-product__name',   // "sepete eklendi" bildirimi
      '.quick-add-modal .product__title h1'
    ]
  };

  /* ================= MANTIK ================= */

  function escapeRegex(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  var brandAlt = CONFIG.BRANDS.map(escapeRegex).join('|');
  var pattern = CONFIG.ONLY_PREFIX
    ? new RegExp('^\\s*(?:' + brandAlt + ')\\s*[-–|:]?\\s*', 'i')
    : new RegExp('\\s*\\b(?:' + brandAlt + ')\\b\\s*[-–|:]?\\s*', 'gi');

  function cleanText(text) {
    var out = text.replace(pattern, CONFIG.ONLY_PREFIX ? '' : ' ');
    out = out.replace(/\s{2,}/g, ' ');
    return out === text ? text : out.replace(/^\s+/, '');
  }

  var selector = CONFIG.SELECTORS.join(',');

  // Öğenin içindeki metin düğümlerini değiştirir; link/etiket yapısına dokunmaz
  function cleanElement(el) {
    if (el.__brandClean) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !node.nodeValue.trim()) continue;
      var cleaned = cleanText(node.nodeValue);
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    }
    el.__brandClean = true;
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(selector)) cleanElement(root);
    var list = root.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) cleanElement(list[i]);
  }

  // Sayfa yüklenirken ve sonradan eklenen (AJAX filtre, sonsuz kaydırma, arama) içerikleri yakala
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  scan(document.documentElement);

  // Tema düzenleyicide bölüm yeniden çizildiğinde
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
  }
  function cozySchedule() {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    idle(cozyStart, { timeout: 3000 });
  }
  if (document.readyState === 'complete') cozySchedule();
  else window.addEventListener('load', cozySchedule, { once: true });
})();
